import React from "react";
import Input from "../../blocks/Input";

export default class EditAtendee extends React.Component {
  state = {
    first_name: "",
    last_name: "",
    email: "",
    errorText: ""
  };

  handleSubmit = e => {
    e.PreventDefault();
    console.log("Form submit clicked");
  };

  handleChange = data => {
    console.log(data);
    let newState = Object.assign(this.state, data);
    this.setState(newState);
  };

  render() {
    return (
      <div className="modal-window-wrapper">
        <div className="inner-modal-window">
          <div className="close-btn">
            <div className="close-btn-wrapper">
              <span />
              <span />
            </div>
          </div>
          <p className="mw-title">Edit Attendee</p>
          <div className="inputs-wrapper">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col">
                  <Input
                    name="first_name"
                    type="text"
                    value={this.state.first_name}
                    handleChange={this.handleChange}
                    placeholder="First Name"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Input
                    name="last_name"
                    type="text"
                    value={this.state.last_name}
                    handleChange={this.handleChange}
                    placeholder="Last Name"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Input
                    name="email"
                    type="email"
                    value={this.state.email}
                    handleChange={this.handleChange}
                    placeholder="Email Address"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="buttons-row">
                <button type="submit" className="btn-submit">
                  Save
                </button>
                <button className="btn-cancel">cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/EditAtendee.jsx